<template>
	<my-popup destroy-on-close :update="false" :visible.sync="visible" :modal-style="modalStyle">
		<div class="progress-container">
            <div class="progress-text" v-if="title" v-text="title"></div>
            <div class="progress-value" v-if="showPro">
            	<div class="progress-bar" :style="style"></div>
            </div>
        </div>
	</my-popup>
</template>

<script>
    import getText from '../getText.js'
	import myPopup from '../../components/my-popup.vue'
	export default {
		name: 'vprogress',
		data() {
			return {
				text: '',
				value: 0,
				image: '',
				myVue: null,
				showPro: false, // 显示进度条
				showPre: false, // 显示百分比
				visible: false
			}
		},
		methods: {
			show(params = {}, visible = false, myVue) {
				this.myVue = myVue;
				this.visible = visible;
				if (visible === true) {
					this.text = params.text || this.text || '';
					this.value = params.value || this.value || 0;
					this.image = params.image || this.image || '';
					this.showPro = 'showPro' in params ? Boolean(params['showPro']) : this.showPro;
					this.showPre = 'showPre' in params ? Boolean(params['showPre']) : this.showPre;
				} else {
					this.text = '';
					this.value = 0;
					this.image = '';
					this.showPro = false;
					this.showPre = false;
				}
			}
		},
		computed: {
			title() {
				const text = getText(this, this.text, '', this.text);
				const percentage = ` ${this.value}%`;
				return text + (this.showPre ? percentage : '');
			},
			style() {
				let width = isNaN(this.value) ? 0 : Number(this.value);
				width = 0 < width ? ((width <= 100) ? width : 100) : 0;
				return `width: ${width}%`;
			},
			modalStyle() {
				const config = Object.create(null);
				config['zIndex'] = 9995;
				if (this.image) {
					config['backgroundImage'] = `url(${this.image})`;
				} else {
					config['backgroundColor'] =  'rgba(0, 0, 0, 0.5)';
				}
				// config['backgroundImage'] = `url(https://panvr.xitohere.com/e/icon/loadingAnimation.gif)`;
				return config;
			}
		},
		components: {
			'my-popup': myPopup
		}
	}
</script>

<style scoped lang="less">
    .progress-container{
        .progress-text{
        	color: #FFFFFF;
        	margin: 0 auto 20px;
        	font-size: 1.6rem;
        	line-height: 2rem;
        	text-align: center;
        	width: calc(100vw - 60px);
        }
        .progress-value{
        	height: 15px;
        	width: calc(100vw - 60px);
        	max-width: 480px;
        	min-width: 230px;
        	overflow: hidden;
        	position: relative;
        	border-radius: 10px;
        	background-color: rgba(255, 255, 255, 0.5);
        	box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
        	.progress-bar{
        		position: absolute;
        		left: 0;
        		top: 50%;
        		height: 100%;
        		border-radius: inherit;
        		transform: translateY(-50%);
        		transition: width 100ms linear;
        		background-color: rgba(255, 255, 255, 0.9);
        	}
        }
    }
</style>
